<template>
    <label
        :for="id"
        class="Checkbox ConsentCheckbox"
        :class="[ { 'checked': modelValue, 'disabled': disabled }, extraClass ]"
    >
        <input
            :id="id"
            type="checkbox"
            style="display: none"
            :disabled="disabled"
            :checked="modelValue"
            @click="onChange"
        >

        <Icon :name="modelValue ? 'checked' : 'unchecked'" />
        <slot />
    </label>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    import Icon from '@/components/common/Icon.vue';

    // PRODUCT-26110 Task 12 (COMPONENT_V_MODEL): migrated to the Vue 3 v-model
    // contract. Consumed via v-model by BulkEmail/Consent(x2)/PastName/StatementOfTruth,
    // and manually (:model-value/@update:model-value) by JsonSchemaBooleanForm(ido).
    @Component({
        emits: [ 'update:modelValue' ],
        components: { Icon },
    })
    export default class Checkbox extends Vue {
        @Prop({ type: String, default: undefined })
        private id!: string;

        @Prop({ type: String, default: undefined })
        private extraClass!: string;

        @Prop({ type: Boolean, default: false })
        private modelValue!: boolean;

        @Prop({ type: Boolean, default: false })
        private disabled!: boolean;

        private onChange(event: Event) {
            if (!this.disabled) {
                this.$emit('update:modelValue', (event.target as HTMLInputElement).checked);
            }
        }
    }
</script>
